import React, { useState } from 'react';
import { Button } from '../../../ui';
import SeoServiceCard from './SeoServiceCard';
import SeoServicesSlider from './SeoServicesSlider';
import { Lottie } from '@crello/react-lottie';
import dots1 from '../../../../public/images/seo/header1.json';
import dots2 from '../../../../public/images/seo/header2.json';
import dotsMobTop from '../../../../public/images/seo/mobile_header_top.json';
import dotsMobButtonBottom from '../../../../public/images/seo/mobile_header3_below button.json';

const SeoService = () => {
  const [website, setWebsite] = useState('');

  const handleChange = e => {
    setWebsite(e.target.value);
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter' && website) {
      window.location.href = `/seo/seo-form?site=${website}`;
    }
  };

  return (
    <div className="bg-[#EEEAF9] h-[calc(100svh-80px)] md:h-auto relative overflow-hidden justify-evenly flex flex-col ">
      <div className="container md:pt-[90px] md:pb-[103px]">
        <div className="flex h-full gap-[20px] lg:flex-row flex-col items-center">
          <div className="flex justify-center items-center w-full flex-1 relative z-20">
            <Lottie
              width={1660}
              height={620}
              playingState={'playing'}
              className="absolute bottom-[-173px] right-[-390px] z-10 hidden lg:block"
              config={{ animationData: dots1, loop: true }}
            />

            <div className="flex flex-col gap-[24px] w-full relative z-30 md:pt-0">
              <Lottie
                playingState={'playing'}
                width={1024}
                height={326}
                className="absolute z-10 block lg:hidden top-[-10px] -translate-y-full right-0"
                config={{ animationData: dotsMobTop, loop: true }}
              />
              <h1 className="uppercase text-black text-[36px] font-[700] leading-[43px]">Guaranteed SEO Services for Measurable Success</h1>
              <div className="flex md:flex-row flex-col item-center gap-y-[16px] md:max-w-[600px] max-w-[450px]">
                <input
                  className="w-full px-[16px] py-[16px] focus:outline-none rounded-[10px] focus:placeholder-transparent relative z-[20]"
                  placeholder="Enter your website"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />

                <div className="flex justify-start min-w-[250px] relative md:right-[45px]">
                  <a href={website ? `/seo/seo-form?site=${website}` : '/seo/seo-form'} className="w-full relative z-[20]">
                    <Button variant="primary" narrowing="horizontal" className="w-full md:w-auto">
                      Get your free SEO plan
                    </Button>
                  </a>

                  <Lottie
                    width={1024}
                    height={326}
                    playingState={'playing'}
                    className="absolute z-[5] block lg:hidden top-[27px] -translate-y-1/2 translate-x-1/4 right-0 -scale-x-1"
                    config={{ animationData: dotsMobButtonBottom, loop: true }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="hidden lg:flex flex-1 h-full items-center relative z-1 lg:mt-0 ">
            <Lottie
              width={1688}
              height={526}
              playingState={'playing'}
              config={{ animationData: dots2, loop: true }}
              className="absolute top-[-84px] left-[-577px] z-10 hidden lg:block"
            />
            <div className="hidden lg:flex flex-col gap-[17px] lg:-mb-[82px] w-full relative z-20">
              <SeoServiceCard
                cardClass="shadow-[0px_0px_13.5px_0px_rgba(0,82,180,0.32)]"
                headerClass="text-[#0052B4]"
                headerText="96"
                suffix="%"
                text="Client Satisfaction Score"
              />
              <SeoServiceCard
                cardClass="md:ml-auto shadow-[0px_0px_13.5px_0px_rgba(217,168,229,0.8)] "
                headerClass="text-[#D9A8E5]"
                headerText="85"
                suffix="%"
                text="Achieve Page 1 in 6 Months"
              />
              <SeoServiceCard
                cardClass="shadow-[0px_0px_13.5px_0px_rgba(247,158,27,0.5)] relative md:bottom-[41px]"
                headerClass="text-[#F79E1B]"
                headerText="300"
                suffix="+"
                text="Top-Ranked Keywords"
              />
              <SeoServiceCard
                cardClass="md:ml-auto shadow-[0px_0px_13.5px_0px_rgba(255,75,85,0.5)] relative md:bottom-[82px]"
                headerClass="text-[#FF4B55]"
                headerText="90"
                suffix="%"
                text="Client Traffic Boost"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="lg:hidden flex items-center h-[45px] py-[10px] header-slider bg-white shadow-[0px_0px_13.5px_0px_rgba(217,168,229,0.8)] mb-[48px]">
        <SeoServicesSlider />
        <Lottie
          playingState={'playing'}
          width={1024}
          height={326}
          className="absolute z-10 block lg:hidden translate-y-[65%] -scale-y-1 right-0"
          config={{ animationData: dotsMobTop, loop: true }}
        />
      </div>
    </div>
  );
};

export default SeoService;
